module.exports = __webpack_public_path__ + "img/transac_illu@2x.8216dbf2.png";